import { createSlice } from '@reduxjs/toolkit'

const productSlice = createSlice({
    name: 'product/state',
    initialState: {
        deleteConfirmation: false,
        selectedProduct: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation, 
    setSortedColumn,
    setSelectedProduct
} = productSlice.actions

export default productSlice.reducer
